// removed by extract-text-webpack-plugin
module.exports = {"form":"hk-form-form"};